<template>
  <gg-modal :is-active="dialogState" @close="close">
    <template v-slot:toolbar>
      IP Address
    </template>
    <template v-slot:body>
      <form>
        <v-text-field
          disabled
          outlined
          v-model="ip_record"
          label="IP Address"
        />
        <v-text-field
          outlined
          v-model="ptr"
          label="PTR"
          name="PTR"
          :error-messages="errors.collect('PTR')"
          v-validate="'required|url'"
        />
      </form>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">
        Cancel
      </gg-btn>
      <gg-btn primary :loading="loading"  @click="save">
        Save
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { isEmpty } from 'Helpers/helpers'

export default {
  name: 'HostingEditIpAddrForm',
  props: {
    ip_record: {
      type: String,
      required: true,
      default: ''
    },
    ptr_record: {
      type: String,
      required: true,
      default: ''
    },
    service_id: {
      type: String,
      required: true,
      default: ''
    },
    dialogState: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data: () => ({
    isEmpty,
    ptr: '',
    loading: false,
  }),
  methods: {
    ...mapActions(['ipUpdate', 'reportError', 'reportSuccess']),
    reset () {
      this.ptr = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    reInitValues () {
      this.ptr = this.ptr_record
    },
    async save () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) return

        this.loading = true
        const data = {
          id: this.service_id,
          ip: this.ip_record,
          ptr: this.ptr
        }

        await this.ipUpdate({ ...data })

        this.reportSuccess('Successfully Updated')
        this.$emit('ip-updated')
        this.loading = false
        this.close()
      } catch (e) {
        this.reportError(e.resultmsg)
        this.loading = false
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  },
  watch: {
    dialogState (val) {
      if (val === true) {
        this.reInitValues()
      } else {
        this.reset()
      }
    }
  },
}
</script>
